import React from "react";
import Title from "../layouts/Title";
import Card from "./Card";
import { MdDeveloperMode } from "react-icons/md";
import { FiFigma } from "react-icons/fi";
import { IoLogoLaravel } from "react-icons/io5";
import { AiOutlineApi } from "react-icons/ai";
import { GrDocumentPerformance } from "react-icons/gr";
import { DiResponsive } from "react-icons/di";
import { RiTeamLine } from "react-icons/ri";
// import { featuresData } from "../../data/data";
const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="Features" des="What I Do" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="Front End Developer"
          des="Experienced in building scalable and responsive web applications using React JS, Angular, Vue JS, JavaScript, TypeScript, and Tailwind CSS."
          icon={<MdDeveloperMode />}
        />
        <Card
          title="UI/UX Designer"
          des="Designing user-friendly interfaces with wireframes, prototypes, responsive layouts, and seamless user experiences focused on usability."
          icon={<FiFigma />}
        />
        <Card
          title="API Integration"
          des="Integrated complex REST APIs, authentication systems, and dynamic data handling for enterprise-level applications."
          icon={<AiOutlineApi />}
        />
        <Card
          title="Performance Optimization"
          des="Optimized web applications for speed, scalability, responsiveness, and reusable architecture to improve overall user experience."
          icon={<GrDocumentPerformance />}
        />
        <Card
          title="Responsive Web Design"
          des="Developed mobile-friendly and cross-browser compatible applications using SCSS, Bootstrap, and Tailwind CSS."
          icon={<DiResponsive />}
        />
        <Card
          title="Agile Team Collaboration"
          des="Worked closely with cross-functional Agile/Scrum teams to deliver high-quality solutions across healthcare, education, and manufacturing domains."
          icon={<RiTeamLine />}
        />
      </div>
    </section>
  );
};

export default Features;